export default __webpack_public_path__ + "static/media/36I-114287_-20977_0.5147d1e8.jpg";